function trackEvent(eventName, payload) {
  if (window.analytics && window.analytics.track) {
    window.analytics.track(eventName, payload);
  }
}

export function trackUserCreated(email, pkey) {
  const payload = { email, pkey };
  trackEvent('User Created', payload);
}

export function trackOnboardingStarted(businessUnit, component) {
  const payload = {
    affiliations: [
      { business_unit: businessUnit, component }
    ]
  };
  // console.log('Onboarding Started: ', businessUnit, component);
  trackEvent('Onboarding Started', payload);
}

export function trackOnboardingCompleted(businessUnit, component) {
  const payload = {
    affiliations: [
      { business_unit: businessUnit, component }
    ]
  };
  // console.log('Onboarding Completed: ', businessUnit, component);
  trackEvent('Onboarding Completed', payload);
}



/** WEBPACK FOOTER **
 ** ./src/util/trackingHelper.js
 **/